
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { stravaAPI } from '../api';
import { useTranslation } from '../i18n';

export const StravaCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [status, setStatus] = useState('connecting'); // connecting | success | error

  useEffect(() => {
    const code = searchParams.get('code');
    const error = searchParams.get('error');

    if (error) {
      setStatus('error');
      return;
    }
    if (!code) {
      setStatus('error');
      return;
    }

    stravaAPI.connect(code)
      .then(() => {
        setStatus('success');
        setTimeout(() => navigate('/settings'), 1500);
      })
      .catch(() => setStatus('error'));
  }, [searchParams, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        {status === 'connecting' && <p>{t('strava.connecting')}</p>}
        {status === 'success' && <p className="text-green-600">{t('strava.connected')}</p>}
        {status === 'error' && <p className="text-red-600">{t('strava.connection_failed')}</p>}
      </div>
    </div>
  );
};